module.exports = __webpack_public_path__ + "static/img/case-dd-page-bg-07.a329b42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/dd/case-dd-page-bg-07.jpg
// module id = Zmbr
// module chunks = 1